module.exports = __webpack_public_path__ + "img/fi-rr-file-gif.ae8faf19.svg";